module.exports = __webpack_public_path__ + "static/media/YF58_7.1d3c3268.jpg";